import React, { Component } from "react";
import { ListingContext, UserContext } from "../../Context";
import _ from "lodash";

import ApplyForm from "../ApplyForm/ApplyForm";
import AppliedCard from "../../components/AppliedCard/AppliedCard";

import Spinner from "@atlaskit/spinner";

import "./applyCard.css";

export default class ApplyCard extends Component {
  render() {
    // console.log(this.state);
    return (
      <div className="apply-card-form">
        <div className="apply-card-apply">
          <UserContext.Consumer>
            {userContext => (
              <ListingContext.Consumer>
                {listingContext => {
                  const my = userContext.my || {};
                  const applications = my.applications || {};
                  const listing = listingContext.listing || {};

                  if (
                    listingContext.loading ||
                    userContext.userLoading ||
                    !!userContext.myLoading ||
                    !!userContext.applicationLoading
                  ) {
                    return (
                      <Spinner
                        delay={0}
                        isCompleting={
                          !listingContext.loading &&
                          !userContext.userLoading &&
                          !userContext.myLoading &&
                          !userContext.applicationLoading
                        }
                        onComplete={() => console.log("test")}
                        size="xlarge"
                      />
                    );
                  } else if (_.isEmpty(listing)) {
                    return null;
                  } else if (
                    Object.keys(applications).indexOf(listing.lid) > -1
                  ) {
                    return (
                      <AppliedCard
                        hideTitle
                        addFlag={this.props.addFlag}
                        listing={listing}
                      />
                    );
                  } else if (!_.isEmpty(listing)) {
                    return (
                      <ApplyForm
                        addFlag={this.props.addFlag}
                        listing={listing}
                      />
                    );
                  }
                }}
              </ListingContext.Consumer>
            )}
          </UserContext.Consumer>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/applyCard/ApplyCard.js